const heading = "_uxsh1fx94ut";

export { heading };
import "./atom.task-heading.style.linaria.module.css";
//# sourceMappingURL=atom.task-heading.style.js.map
